<template>
  <!--  只允许一个 组件 -->
  <a-layout class="center-container">
    <!--中间布局 background: '#fff', -->
    <a-layout-content class="center-div"
      :style="{ background: '#fff', padding: '85px 50px 50px 50px', margin: 0, minHeight: '720px' }">

      <!-- 内容详情卡片包裹 -->
      <!-- <a-card :hoverable="false" :bordered="true" style="padding: 20px;" :bodyStyle="{ padding: '25px' }"
        :type="'inner'" class="card">      </a-card> -->

      <!-- 展示图书列表 -->
      <the-tracks-card :data="tracks"></the-tracks-card>

    </a-layout-content>

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, reactive, toRef } from 'vue';
// 引入axios 库
import axios from "axios";
import { message } from "ant-design-vue";

import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
import useRouter from '@/router'
import TheTracksCard from '@/components/the-tracks-card.vue';
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'Track',
  components: {
    TheTracksCard,
    TheFooter
  },
  setup() {
    console.log('setup ...')

    // 获取url参数 http://localhost:9999/?categoryId=101
    const route = useRoute();

    let tracks = ref();

    /**
     * 查询分类的电子书列表
     */
    const handleQuery = () => {

      axios.post("/track/list", {
        page: 1,
        size: 1000,
        status: 1
      }).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          //ref
          tracks.value = result.data.list
        } else {
          message.error(result.message);
        }
      });
    };


    onMounted(() => {
      console.log('onMounted ...')

      handleQuery()

    })
    return {

      tracks,

    }


  }
});
</script>

<style scoped>
/*电子书图标形状*/
.ant-avatar {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 1%;
  margin: 0px 0;
}

/* 限定描述 3 行 */
.description {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
